<span tabindex="0" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()">
  {{ translate ? (triggerText | translate) : triggerText }}
</span>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" [hasBackdrop]="true" (overlayOutsideClick)="isOpen = false">
  <div class="event-status circlestatusBoard" style="border-radius: 12px">
    <ul>
      <li *ngIf="allowNullOption" (click)="selectOption(null)">
        {{ translate ? (nullOptionText | translate) : nullOptionText }}
      </li>
      <li class="font-14" *ngFor="let opt of sortedOptions" (click)="selectOption(opt)">
        {{ translate ? (getLabel(opt) | translate) : getLabel(opt) }}
      </li>
    </ul>
  </div>
</ng-template>
